import { isMac } from '../../../utils/isMac'

export const globalSearchShortcutLabel = isMac ? '⌘+S' : 'Ctrl+S'
